import React, { useState } from "react";
import { Container, Row, Col, Modal, Form, Button } from "react-bootstrap";
import "./UpcomingEvents.css";

import event1 from "../../assets/corp-ev-3.JPG";
import event2 from "../../assets/wedding.jpg";
import event3 from "../../assets/gallery-5.jpeg";
import event4 from "../../assets/comming-4.jpg";

const events = [
  {
    title: "College Events",
    description:
      "Exciting college fests, orientations, and annual days with creative themes and smooth coordination.",
    image: event1,
  },
  {
    title: "Corporate Events",
    description:
      "Professional events for launches, conferences, and team-building—tailored to your brand’s goals.",
    image: event2,
  },
  {
    title: "Monsoon Events",
    description:
      "Celebrate the rainy season with indoor themes, rain dances, and unique décor experiences.",
    image: event3,
  },
  {
    title: "HR Meet",
    description:
      "Seamless HR meets focused on networking, collaboration, and impactful knowledge sharing.",
    image: event4,
  },
];




const UpcomingEvents = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleShow = (event) => {
    setSelectedEvent(event);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedEvent(null);
    setFormData({ name: "", email: "", phone: "", message: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Booking Submitted:", { ...formData, event: selectedEvent?.title });
    alert("Booking submitted successfully!");
    handleClose();
  };

  return (
    <section className="upcoming-events-section">
      <Container>
        <h2 className="section-title text-center">Upcoming Events</h2>
        <p className="section-subtitle text-center">
          Discover exciting opportunities to learn, connect, and grow.
        </p>
        <Row>
        

          <Col md={12}>
            <Row>
             {events.map((event, index) => (
  <Col md={6} className="event-box" key={index}>
    <img src={event.image} alt={event.title} className="event-img" />
    <div className="event-details">
      <h5>{event.title}</h5>
      <p className="event-description">{event.description}</p>
      <Button className="book-btn mt-2" onClick={() => handleShow(event)}>
        Stay Tuned
      </Button>
    </div>
  </Col>
))}

            </Row>
          </Col>
        </Row>

        {/* Modal */}
        <Modal show={showModal} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Book Event</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Event</Form.Label>
                <Form.Control type="text" readOnly value={selectedEvent?.title || ""} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Message</Form.Label>
                <Form.Control as="textarea" rows={3} name="message" value={formData.message} onChange={handleChange} />
              </Form.Group>
               <Button onClick={handleShow} className="learn-more-btn rounded-pill px-4 py-2 text-white">
                               Submit Book
                            </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </Container>
    </section>
  );
};

export default UpcomingEvents;
